export default __webpack_public_path__ + "static/media/3.b298a31a.png";